// 2026 India Marketplace Shopping Festivals
// Banner auto-activates 7 days BEFORE start_date, deactivates 1 day AFTER end_date
//
// Each festival should have a marketplace-onboarding angle (we are an onboarding agency, not a retailer)

export const FESTIVALS_2026 = [
  {
    id: 'republic-day-2026',
    name: 'Republic Day Sale',
    emoji: '🇮🇳',
    start_date: '2026-01-22',
    end_date: '2026-01-26',
    color_from: 'from-orange-500',
    color_via: 'via-white',
    color_to: 'to-green-600',
    text_color: 'text-slate-900',
    headline: 'Republic Day Sale incoming!',
    sub: "Last call to get listed before India's biggest January sale event. Onboard to Myntra, Nykaa & Ajio in 14 days.",
    cta_text: 'Book Free Audit',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=republic-day-2026'
  },
  {
    id: 'holi-2026',
    name: 'Holi',
    emoji: '🎨',
    start_date: '2026-03-14',
    end_date: '2026-03-14',
    color_from: 'from-pink-500',
    color_via: 'via-yellow-400',
    color_to: 'to-purple-600',
    text_color: 'text-white',
    headline: 'Holi Festive Catalog is now LIVE!',
    sub: 'Fashion brands listed on Myntra/Ajio see 3-4× spike during Holi week. Onboard now to capture the wave.',
    cta_text: 'Start Onboarding',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=holi-2026'
  },
  {
    id: 'eid-fitr-2026',
    name: 'Eid al-Fitr',
    emoji: '🌙',
    start_date: '2026-03-30',
    end_date: '2026-03-31',
    color_from: 'from-emerald-600',
    color_via: 'via-teal-500',
    color_to: 'to-amber-500',
    text_color: 'text-white',
    headline: 'Eid Sale Surge — Be Listed in Time',
    sub: 'Ethnic wear, perfumes & gifting categories peak 5× in Eid week. Get approved across marketplaces fast.',
    cta_text: 'Book Free Audit',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=eid-2026'
  },
  {
    id: 'akshaya-tritiya-2026',
    name: 'Akshaya Tritiya',
    emoji: '✨',
    start_date: '2026-04-30',
    end_date: '2026-04-30',
    color_from: 'from-amber-500',
    color_via: 'via-yellow-500',
    color_to: 'to-orange-600',
    text_color: 'text-white',
    headline: 'Akshaya Tritiya — Gold & Jewellery Wave',
    sub: 'Jewellery & home essentials brands: get onboard to Tata CliQ, Pernia, Aza before the auspicious buying surge.',
    cta_text: 'Start Onboarding',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=akshaya-tritiya-2026'
  },
  {
    id: 'raksha-bandhan-2026',
    name: 'Raksha Bandhan',
    emoji: '🪢',
    start_date: '2026-08-28',
    end_date: '2026-08-28',
    color_from: 'from-rose-500',
    color_via: 'via-pink-500',
    color_to: 'to-amber-500',
    text_color: 'text-white',
    headline: 'Rakhi Gifting Season — Are You Live?',
    sub: 'Gifting, fashion, beauty & jewellery brands win big during Rakhi. List in 14 days with our onboarding team.',
    cta_text: 'Book Free Audit',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=rakhi-2026'
  },
  {
    id: 'independence-day-2026',
    name: 'Independence Day',
    emoji: '🇮🇳',
    start_date: '2026-08-15',
    end_date: '2026-08-15',
    color_from: 'from-orange-500',
    color_via: 'via-white',
    color_to: 'to-green-600',
    text_color: 'text-slate-900',
    headline: 'Independence Day Sale Week',
    sub: 'Amazon Freedom Sale + Flipkart Big Saving Days launch. Have your catalog approved & ready to scale.',
    cta_text: 'Start Onboarding',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=independence-day-2026'
  },
  {
    id: 'onam-2026',
    name: 'Onam',
    emoji: '🌼',
    start_date: '2026-09-06',
    end_date: '2026-09-06',
    color_from: 'from-yellow-500',
    color_via: 'via-amber-500',
    color_to: 'to-orange-600',
    text_color: 'text-white',
    headline: 'Onam — South India Festive Wave',
    sub: 'Ethnic wear, sarees, home decor & ayurveda brands see 4× lift in Kerala/TN. Onboard for the surge.',
    cta_text: 'Book Free Audit',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=onam-2026'
  },
  {
    id: 'navratri-2026',
    name: 'Navratri',
    emoji: '💃',
    start_date: '2026-09-22',
    end_date: '2026-10-01',
    color_from: 'from-fuchsia-600',
    color_via: 'via-rose-500',
    color_to: 'to-orange-500',
    text_color: 'text-white',
    headline: 'Navratri — 9 Nights of Fashion Sales',
    sub: 'Ethnic wear, jewellery & beauty brands see record GMV. Get listed on Myntra & Ajio before garba season.',
    cta_text: 'Start Onboarding',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=navratri-2026'
  },
  {
    id: 'dussehra-2026',
    name: 'Dussehra',
    emoji: '🏹',
    start_date: '2026-10-02',
    end_date: '2026-10-02',
    color_from: 'from-red-600',
    color_via: 'via-orange-500',
    color_to: 'to-amber-400',
    text_color: 'text-white',
    headline: 'Dussehra Festive Sale',
    sub: 'Amazon Great Indian Festival + Flipkart Big Billion launching. Last call to onboard before the rush.',
    cta_text: 'Book Free Audit',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=dussehra-2026'
  },
  {
    id: 'karva-chauth-2026',
    name: 'Karva Chauth',
    emoji: '🌙',
    start_date: '2026-10-30',
    end_date: '2026-10-30',
    color_from: 'from-rose-500',
    color_via: 'via-red-500',
    color_to: 'to-amber-500',
    text_color: 'text-white',
    headline: 'Karva Chauth — Beauty & Jewellery Surge',
    sub: 'Beauty, jewellery & ethnic wear brands peak this week. List on Nykaa, Tira & Tata CliQ in 14 days.',
    cta_text: 'Start Onboarding',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=karva-chauth-2026'
  },
  {
    id: 'dhanteras-2026',
    name: 'Dhanteras',
    emoji: '🪔',
    start_date: '2026-11-06',
    end_date: '2026-11-06',
    color_from: 'from-amber-500',
    color_via: 'via-yellow-500',
    color_to: 'to-orange-600',
    text_color: 'text-white',
    headline: 'Dhanteras — Gold, Electronics & Home',
    sub: 'India\'s biggest buying day. Be live on Amazon, Flipkart, Tata CliQ before Lakshmi-Puja shoppers arrive.',
    cta_text: 'Book Free Audit',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=dhanteras-2026'
  },
  {
    id: 'diwali-2026',
    name: 'Diwali',
    emoji: '🪔',
    start_date: '2026-11-08',
    end_date: '2026-11-08',
    color_from: 'from-yellow-500',
    color_via: 'via-orange-500',
    color_to: 'to-rose-600',
    text_color: 'text-white',
    headline: 'Diwali Sale 2026 — India\'s Biggest Shopping Event',
    sub: 'Brands listed before Diwali drive 60-70% of annual GMV in 1 month. Onboard NOW to capture the wave.',
    cta_text: 'Start Onboarding',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=diwali-2026'
  },
  {
    id: 'christmas-2026',
    name: 'Christmas',
    emoji: '🎄',
    start_date: '2026-12-25',
    end_date: '2026-12-25',
    color_from: 'from-red-600',
    color_via: 'via-green-600',
    color_to: 'to-amber-500',
    text_color: 'text-white',
    headline: 'Christmas & End-of-Year Sales',
    sub: 'Year-end gifting, fashion, beauty & home brands win. Be approved before final-quarter customer rush.',
    cta_text: 'Book Free Audit',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=christmas-2026'
  },
  {
    id: 'new-year-2026',
    name: 'New Year',
    emoji: '🎆',
    start_date: '2026-12-31',
    end_date: '2026-12-31',
    color_from: 'from-indigo-600',
    color_via: 'via-purple-600',
    color_to: 'to-pink-500',
    text_color: 'text-white',
    headline: 'New Year Sale — Start 2027 Right',
    sub: 'Brands listed by New Year capture January seasonal buyers. Free brand audit available.',
    cta_text: 'Start Onboarding',
    cta_link: '/contact?utm_source=banner&utm_medium=festival&utm_campaign=new-year-2026'
  }
];

/**
 * Returns the festival that is currently in its banner window
 * Window: 7 days BEFORE start_date through 1 day AFTER end_date.
 * If multiple festivals overlap, returns the one whose start_date is closest (most relevant).
 */
export const getActiveFestival = (now = new Date()) => {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const active = FESTIVALS_2026
    .map(f => {
      const start = new Date(f.start_date + 'T00:00:00');
      const end = new Date(f.end_date + 'T00:00:00');
      const windowStart = new Date(start);
      windowStart.setDate(windowStart.getDate() - 7);
      const windowEnd = new Date(end);
      windowEnd.setDate(windowEnd.getDate() + 1);
      return { ...f, windowStart, windowEnd, start, end };
    })
    .filter(f => today >= f.windowStart && today <= f.windowEnd);

  if (active.length === 0) return null;
  // Pick the one whose start is closest to (or in) today
  active.sort((a, b) => Math.abs(a.start - today) - Math.abs(b.start - today));
  return active[0];
};
